import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetPlantationsInputDto, PlantationCreateDto, PlantationDto, PlantationExcelDownloadDto, PlantationUpdateDto } from '../dtos/plantation/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class PlantationService {
  private restService = inject(RestService);
  apiName = 'Geographic';
  

  create = (input: PlantationCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PlantationDto>({
      method: 'POST',
      url: '/api/geographic/plantations',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/geographic/plantations/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/geographic/plantations',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PlantationDto>({
      method: 'GET',
      url: `/api/geographic/plantations/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/geographic/plantations/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetPlantationsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<PlantationDto>>({
      method: 'GET',
      url: '/api/geographic/plantations',
      params: { rotationId: input.rotationId, rotationName: input.rotationName, geneticMaterialId: input.geneticMaterialId, spacingId: input.spacingId, plantationTypeId: input.plantationTypeId, plantationDate: input.plantationDate, plantationDateFrom: input.plantationDateFrom, plantationDateTo: input.plantationDateTo, plantationArea: input.plantationArea, plantationAreaFrom: input.plantationAreaFrom, plantationAreaTo: input.plantationAreaTo, plantedSeedlings: input.plantedSeedlings, plantedSeedlingsFrom: input.plantedSeedlingsFrom, plantedSeedlingsTo: input.plantedSeedlingsTo, seedlingOriginId: input.seedlingOriginId, isPlantationCompleted: input.isPlantationCompleted, isOwnPlantation: input.isOwnPlantation, packingTypeId: input.packingTypeId, processedDate: input.processedDate, processedDateFrom: input.processedDateFrom, processedDateTo: input.processedDateTo, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: PlantationExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/geographic/plantations/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, rotationId: input.rotationId, rotationName: input.rotationName, geneticMaterialId: input.geneticMaterialId, spacingId: input.spacingId, plantationTypeId: input.plantationTypeId, plantationDate: input.plantationDate, plantationDateFrom: input.plantationDateFrom, plantationDateTo: input.plantationDateTo, plantationArea: input.plantationArea, plantationAreaFrom: input.plantationAreaFrom, plantationAreaTo: input.plantationAreaTo, plantedSeedlings: input.plantedSeedlings, plantedSeedlingsFrom: input.plantedSeedlingsFrom, plantedSeedlingsTo: input.plantedSeedlingsTo, seedlingOriginId: input.seedlingOriginId, isPlantationCompleted: input.isPlantationCompleted, isOwnPlantation: input.isOwnPlantation, packingTypeId: input.packingTypeId, processedDate: input.processedDate, processedDateFrom: input.processedDateFrom, processedDateTo: input.processedDateTo, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PlantationDto[]>({
      method: 'GET',
      url: '/api/geographic/plantations/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: PlantationUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PlantationDto>({
      method: 'PUT',
      url: `/api/geographic/plantations/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}